import styled from "styled-components/macro";

export default styled.div`
  max-width: 500px;
  /* max-height: 250px; */
  max-height: 540px;

  @media (min-width: 740px) and (min-height: 440px) {
    max-width: 690px;
    max-height: ${({ isHealthCheckTablet }) => (isHealthCheckTablet ? "640px" : "570px")};
  }

  @media (min-width: 992px) and (min-height: 595px) {
    max-width: 930px;
    max-height: ${({ isHealthCheckTablet }) => (isHealthCheckTablet ? "540px" : "465px")};
  }

  @media (min-width: 1200px) and (min-height: 710px) {
    max-width: 1110px;
    max-height: ${({ isHealthCheckTablet }) => (isHealthCheckTablet ? "640px" : "555px")};
  }

  @media (min-width: 1400px) and (min-height: 830px) {
    max-width: 1290px;
    max-height: ${({ isHealthCheckTablet }) => (isHealthCheckTablet ? "740px" : "645px")};
  }

  @media (min-width: 1590px) and (min-height: 940px) {
    max-width: 1470px;
    max-height: ${({ isHealthCheckTablet }) => (isHealthCheckTablet ? "840px" : "735px")};
  }

  @media (min-width: 1840px) and (min-height: 1080px) {
    max-width: 1690px;
    max-height: ${({ isHealthCheckTablet }) => (isHealthCheckTablet ? "970px" : "845px")};
  }

  @media (min-width: 2000px) and (min-height: 1220px) {
    max-width: 1910px;
    max-height: ${({ isHealthCheckTablet }) => (isHealthCheckTablet ? "1100px" : "955px")};
  }

  /* Tablet mode: fill the space between the fixed top navbar (3.75em)
     and bottom navbar (3.4em + 0.5em margin) instead of the stepped
     fixed sizes above, which leave large unused gaps on tablet screens */
  ${({ theme }) =>
    theme.isTablet &&
    `
    && {
      max-width: calc(100vw - 1.2em);
      max-height: calc(100vh - 8.4em);
    }
  `}

  margin-left: auto;
  margin-right: auto;

  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  position: relative;
`;
